// extracted by mini-css-extract-plugin
module.exports = {"ModalClientUpgrade":"ModalClientUpgrade_ModalClientUpgrade__geW6M","grid":"ModalClientUpgrade_grid__qIOMp"};